import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { StatusBadge } from "@/components/Primitives";

export default function Network() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/network/devices").then(r => setItems(r.data)); }, []);
  const startScan = async () => {
    await api.post("/network/scan", { subnet: "10.0.0.0/24" });
  };
  return (
    <div className="space-y-4">
      <div className="flex items-end justify-between">
        <div>
          <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500 font-mono">Network Discovery & Topology</div>
          <h1 className="font-display text-3xl font-semibold tracking-tight mt-1">Discovered Devices ({items.length})</h1>
        </div>
        <button onClick={startScan} data-testid="network-scan-btn" className="bg-blue-600 hover:bg-blue-700 text-white text-sm rounded-md px-3 py-2">Start Subnet Scan</button>
      </div>
      <div className="bg-zinc-950 border border-zinc-900 rounded-md overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-zinc-900/50 text-[10px] uppercase tracking-widest text-zinc-500 font-mono"><tr><th className="text-left px-4 py-3">Name</th><th className="text-left px-4 py-3">Kind</th><th className="text-left px-4 py-3">Vendor</th><th className="text-left px-4 py-3">IP</th><th className="text-left px-4 py-3">MAC</th><th className="text-left px-4 py-3">VLAN</th><th className="text-left px-4 py-3">Status</th></tr></thead>
          <tbody>
            {items.map(d => (
              <tr key={d.id} className="border-b border-zinc-900 hover:bg-zinc-900/40">
                <td className="px-4 py-2 font-mono">{d.name}</td>
                <td className="px-4 py-2 text-zinc-400 capitalize">{d.kind}</td>
                <td className="px-4 py-2 text-zinc-400">{d.vendor}</td>
                <td className="px-4 py-2 font-mono text-xs">{d.ip}</td>
                <td className="px-4 py-2 font-mono text-xs text-zinc-500">{d.mac}</td>
                <td className="px-4 py-2 font-mono text-xs">{d.vlan}</td>
                <td className="px-4 py-2"><StatusBadge status={d.status}/></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
